import styled from 'styled-components';

export default styled.span`
  flex-grow: 1;
  margin-left: 5px;
`;
